export class RespuestaDocumentModel{
    id: string;
    idTarea: string;
    descripcion: string;
}
